import React from "react";
import { Alert, Col, Row } from "components/bootstrap";
import commonStyles from "../common/commonStyles.css";
const EventDefinitionValidationSummary = ({
  validation = {
    errors: []
  }
}) => {
  const fieldsWithErrors = Object.keys(validation.errors);
  if (fieldsWithErrors.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: commonStyles.validationSummary, title: "We found some errors!" }, /* @__PURE__ */ React.createElement("p", null, "Please correct the following errors before saving this Event Definition:"), /* @__PURE__ */ React.createElement("ul", null, fieldsWithErrors.map(
    (field) => validation.errors[field].map((error) => {
      const effectiveError = field === "config" ? error.replace("config", "condition") : error;
      return /* @__PURE__ */ React.createElement("li", { key: `${field}-${effectiveError}` }, effectiveError);
    })
  )))));
};
export default EventDefinitionValidationSummary;
